<template>
  <div class="wrapper">
    <div class="select" @click="setShow($event)">
      <div>{{ status }}</div>
      <div class="arrow-down">
        <i class="material-icons align-middle">unfold_more</i>
      </div>
    </div>
    <div v-if="show" class="options">
      <div
        class="item"
        v-for="(item, index) in statusOptions"
        :key="index"
        @click="onClickItem(item.value, $event)"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ["status", "statusOptions", "roleId", "consultantId"],
  data() {
    return {
      show: false,
    };
  },
  methods: {
    setShow(event) {
      event.stopPropagation();
      this.show = !this.show;
    },
    onClickItem(value, event) {
      event.stopPropagation();
      this.show = false;
      let reason = null;
      let emailContent = null;
      if (value === this.status) return;
      // if (value === "Rejected") {
      //   reason = prompt("Rejected reason:");
      // }
      // if (value === "Submitted") {
      //   emailContent = prompt("Email content:");
      // }
      this.$emit("onUpdate", {
        roleId: this.roleId,
        consultantId: this.consultantId,
        status: value,
        reason,
        emailContent,
      });
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
}
.select {
  border: 1px solid #e8e8e8;
  display: flex;
  align-self: start;
  align-items: center;
  justify-content: space-between;
  border-radius: 13px;
  width: 100px;
  color: #585757;
  cursor: pointer;
  background: #ffffff;
  padding: 4px 12px;
}
.arrow-down {
  margin-left: 5px;
  margin-right: -3px;
  /*width: 0;*/
  /*height: 0;*/
  /*border-left: 6px solid transparent;*/
  /*border-right: 6px solid transparent;*/
  /*border-top: 6px solid #979797;*/
  /*margin-left: 8px;*/
}
.options {
  border: 1px solid #e8e8e8;
  width: 100%;
  max-height: 84px;
  background-color: #ffffff !important;
  position: absolute;
  top: calc(100% + 4px);
  border-radius: 8px;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.options::-webkit-scrollbar {
  display: none;
}
.item {
  color: #979797;
  padding: 4px 12px;
  line-height: 20px;
  cursor: pointer;
}
.item:hover {
  background: rgb(238, 238, 238);
}
</style>
